<template>
  <div class="notice-container">
    <div class="header">
      <h2>公告资讯管理</h2>
      <el-button type="primary" @click="handleAdd">
        <i class="el-icon-plus"></i> 添加公告
      </el-button>
    </div>

    <!-- 公告列表 -->
    <el-table :data="noticeList" border style="width: 100%" max-height="600px" v-loading="loading">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="url" label="链接"></el-table-column>
      <el-table-column prop="release_time" label="发布时间"></el-table-column>
      <!-- 公告类型列，根据类型显示不同颜色的标签 -->
      <el-table-column prop="type" label="类型" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type === '公告' ? 'primary' : 'success'">
            {{ scope.row.type }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="update_time"
        label="更新时间"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 添加/编辑公告对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="noticeForm"
        :rules="rules"
        ref="noticeForm"
        label-width="80px"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            v-model="noticeForm.title"
            placeholder="请输入公告标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input
            v-model="noticeForm.url"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="release_time">
          <el-input
            v-model="noticeForm.release_time"
            placeholder="请输入发布时间"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="noticeForm.type" placeholder="请选择公告类型">
            <el-option label="公告" value="公告"></el-option>
            <el-option label="资讯" value="资讯"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, addInfo, editInfo, delInfo } from "@/api";
export default {
  name: "Notice",
  data() {
    return {
      loading: false, // 加载状态标志
      noticeList: [], // 公告列表数据
      currentPage: 1, // 当前页码
      pageSize: 20, // 每页显示条数
      total: 0, // 总记录数
      dialogVisible: false, // 对话框显示状态
      dialogTitle: "添加公告", // 对话框标题
      editId: "", // 编辑时的公告ID
      // 表单数据对象
      noticeForm: {
        url: "", // 跳转链接
        title: "", // 公告标题
        type: "", // 公告类型
        release_time: "", // 发布时间
      },
      // 表单验证规则
      rules: {
        title: [
          { required: true, message: "请输入公告标题", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        url: [{ required: true, message: "请输入跳转链接", trigger: "blur" }],
        release_time: [
          { required: true, message: "请输入发布时间", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择公告类型", trigger: "change" },
        ],
      },
    };
  },
  // 组件创建时执行
  created() {
    this.getNoticeList(); // 获取公告列表数据
  },
  methods: {
    // 获取公告列表数据
    getNoticeList() {
      this.loading = true; // 显示加载状态
      // 调用API接口获取数据
      getInfo({
        model: "notice", // 模型名称
        condition: {}, // 查询条件
        page: this.currentPage, // 当前页码
        pagesize: this.pageSize, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.noticeList = res.data.data; // 设置公告列表数据
          this.total = res.data.page_info.total_size; // 设置总记录数
          this.loading = false; // 隐藏加载状态
        }
      });
    },

    // 添加公告
    handleAdd() {
      this.dialogTitle = "添加公告"; // 设置对话框标题
      this.editId = ""; // 清空编辑ID
      // 重置表单数据
      this.noticeForm = {
        title: "",
        url: "",
        release_time: "",
        type: "",
        // status: true, // 注释掉的状态字段
      };
      this.dialogVisible = true; // 显示对话框
    },

    // 编辑公告
    handleEdit(row) {
      this.dialogTitle = "编辑公告"; // 设置对话框标题
      this.editId = row._id; // 设置编辑ID
      this.noticeForm = { ...row }; // 复制行数据到表单
      this.dialogVisible = true; // 显示对话框
    },

    // 删除公告
    handleDelete(row) {
      // 显示确认对话框
      this.$confirm("确认删除该公告?", "提示", {
        type: "warning",
      })
        .then(() => {
          // 用户确认删除
          this.editId = row._id; // 设置要删除的ID
          // 调用删除API
          delInfo({
            model: "notice", // 模型名称
            _id: this.editId, // 要删除的ID
          }).then((res) => {
            if (res.status == 200) {
              this.$message.success("删除成功"); // 显示成功消息
              this.getNoticeList(); // 重新获取列表数据
            }
          });
        })
        .catch(() => {}); // 用户取消删除时不做处理
    },

    // 提交表单
    submitForm() {
      // 表单验证
      this.$refs.noticeForm.validate((valid) => {
        if (valid) {
          // 根据是否有editId判断是编辑还是新增
          if (this.editId) {
            // 编辑现有公告
            editInfo({
              model: "notice", // 模型名称
              condition: {}, // 查询条件
              _id: this.editId, // 要编辑的ID
              data: {
                ...this.noticeForm, // 表单数据
              },
            }).then((res) => {
              if (res.status == 200) {
                this.$message.success(this.dialogTitle + "成功"); // 显示成功消息
                this.dialogVisible = false; // 关闭对话框
                this.getNoticeList(); // 重新获取列表数据
              }
            });
          } else {
            // 添加新公告
            addInfo({
              model: "notice", // 模型名称
              condition: {}, // 查询条件
              data: {
                ...this.noticeForm, // 表单数据
              },
            }).then((res) => {
              if (res.status == 200) {
                this.$message.success(this.dialogTitle + "成功"); // 显示成功消息
                this.dialogVisible = false; // 关闭对话框
                this.getNoticeList(); // 重新获取列表数据
              }
            });
          }
        }
      });
    },

    // 每页显示条数变化时的处理函数
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页显示条数
      this.getNoticeList(); // 重新获取列表数据
    },
    // 当前页变化时的处理函数
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.getNoticeList(); // 重新获取列表数据
    },
  },
};
</script>

<style scoped>
.notice-container {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.el-tag {
  min-width: 60px;
  text-align: center;
}
</style>